import React from "react";
import PageContent from "./PageContent";

const TermsConditions = () => {
  return <PageContent tag="HELP_PAGE_WD" id="5e948d2c29196b814ff733f5" />;
};

export default TermsConditions;
